// extracted by mini-css-extract-plugin
export var dropdownContainer = "_q1-0";
export var leftAlign = "_q1-4";
export var listItem = "_q1-2";
export var listItemWrapper = "_q1-1";
export var operationText = "_q1-3";